export default "__VITE_ASSET__BqqD8JcO__"